export const outrightsQueryFactory = (leagueId) => {
    return {
        id: leagueId
    };
};
//# sourceMappingURL=MarketGroupQueries.js.map